import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import { IngredientCreateObservationsPage } from '../../ingredient-create/ingredient-create-observations/ingredient-create-observations';

/**
 * Generated class for the DishViewPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view-observations',
    templateUrl: 'ingredient-view-observations.html',
})
export class IngredientViewObservationsPage {
    @Input() ingredient: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
                    
    }

    edit(){
        this.navCtrl.push(IngredientCreateObservationsPage, {
            ingredient_uid: this.ingredient.UID,
            ingredient_name:this.ingredient.name,
            observations: this.ingredient.observations,
        })
    }


}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-observations/ingredient-view-observations.ts